import { useTranslate } from "ra-core";

import type { LeadType } from "../types";
import { leadTypeTranslationKey } from "./leadTypes";

/**
 * Almikia Epic EL3: the lead TYPE (who generated the lead) with its plain-language definition
 * as visible help text (no hover needed, so it also works on touch). Rendered as a bordered
 * badge so it never reads as the lead ORIGIN / source field next to it.
 */
export const LeadTypeField = ({
  leadType,
  className = "mr-10 max-w-xs",
}: {
  leadType: LeadType;
  className?: string;
}) => {
  const translate = useTranslate();
  return (
    <div className={`flex flex-col ${className}`} data-testid="lead-type-field">
      <span className="text-xs text-muted-foreground tracking-wide">
        {translate("resources.deals.fields.lead_type")}
      </span>
      <span className="mt-0.5 w-fit rounded-md border px-2 py-0.5 text-sm font-medium">
        {translate(leadTypeTranslationKey(leadType))}
      </span>
      <span className="mt-1 text-xs text-muted-foreground">
        {translate(`resources.deals.lead_type_definitions.${leadType}`)}
      </span>
    </div>
  );
};
